import type { View } from '@/modules/Editor/views/view'
import { getEditingAnnotation } from './getEditingAnnotation'

/**
 * Returns the selected annotation id.
 * When the selected annotation has a different class from the one selected for the tool, then
 * returns undefined, as editing with a different class is not possible.
 */
export const getEditingAnnotationId = (view: View): string | undefined => {
  const selectedAnnotation = getEditingAnnotation(view)

  if (!selectedAnnotation) {
    return undefined
  }

  return selectedAnnotation.id
}
